(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-page]');
    if (!root) return;

    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = root.querySelectorAll('[data-thumb]');
    const variantIdInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const addBtnText = root.querySelector('[data-add-to-cart-text]');
    const availabilityEl = root.querySelector('[data-availability]');
    const optionButtons = root.querySelectorAll('[data-option-value]');

    const selected = {};
    const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
    if (firstAvailable && firstAvailable.options) {
      firstAvailable.options.forEach((val, i) => {
        selected[i] = val;
      });
    }

    // Prefer currently selected options from aria-selected markup
    root.querySelectorAll('.variant-picker').forEach((picker) => {
      const index = Number(picker.dataset.optionIndex);
      const active = picker.querySelector('.variant-option.is-selected');
      if (active) selected[index] = active.dataset.optionValue;
    });

    function getSelectedOptions() {
      const count = product.options ? product.options.length : 0;
      const opts = [];
      for (let i = 0; i < count; i++) opts.push(selected[i]);
      return opts;
    }

    function findVariant(options) {
      return product.variants.find((variant) =>
        variant.options.every((opt, i) => opt === options[i])
      );
    }

    function optionValueAvailable(optionIndex, value) {
      return product.variants.some((variant) => {
        if (variant.options[optionIndex] !== value) return false;
        return variant.options.every((opt, i) => {
          if (i === optionIndex) return true;
          if (selected[i] == null) return true;
          return opt === selected[i];
        }) && variant.available;
      });
    }

    function optionValueExists(optionIndex, value) {
      return product.variants.some((variant) => {
        if (variant.options[optionIndex] !== value) return false;
        return variant.options.every((opt, i) => {
          if (i === optionIndex) return true;
          if (selected[i] == null) return true;
          return opt === selected[i];
        });
      });
    }

    function setMainImage(src, srcset, alt) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      if (srcset) mainImage.srcset = srcset;
      if (alt) mainImage.alt = alt;
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="product-page__price--sale" data-price-sale>' +
          variant.price_formatted +
          '</span> <s data-price-compare>' +
          variant.compare_at_price_formatted +
          '</s>';
      } else {
        priceEl.innerHTML = '<span data-price-regular>' + variant.price_formatted + '</span>';
      }
    }

    function updateUI() {
      const options = getSelectedOptions();
      const variant = findVariant(options);

      // Option button states
      optionButtons.forEach((btn) => {
        const index = Number(btn.dataset.optionIndex);
        const value = btn.dataset.optionValue;
        const isSelected = selected[index] === value;
        const available = optionValueAvailable(index, value);
        const exists = optionValueExists(index, value);

        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        btn.classList.toggle('is-unavailable', !available);
        btn.disabled = !exists;
      });

      // Always show the selected option name next to the option label (e.g. Color: Black)
      root.querySelectorAll('.variant-picker').forEach((picker) => {
        const index = Number(picker.dataset.optionIndex);
        const label = picker.querySelector('[data-option-value-label]');
        if (label && selected[index] != null) {
          label.textContent = selected[index];
        }
      });

      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        if (availabilityEl) {
          availabilityEl.hidden = false;
          availabilityEl.textContent = 'That combination isn’t available.';
        }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      updatePrice(variant);

      if (variant.featured_image) {
        setMainImage(
          variant.featured_image.src,
          variant.featured_image.srcset,
          variant.featured_image.alt
        );
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) {
        addBtnText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (availabilityEl) {
        if (variant.available) {
          availabilityEl.hidden = true;
          availabilityEl.textContent = '';
        } else {
          availabilityEl.hidden = false;
          availabilityEl.textContent = 'Sold out in this combination.';
        }
      }
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const index = Number(btn.dataset.optionIndex);
        selected[index] = btn.dataset.optionValue;
        updateUI();
      });
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMainImage(thumb.dataset.imageSrc, thumb.dataset.imageSrcset, thumb.dataset.imageAlt);
        thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });

    updateUI();
  })();

  } catch(e) { console.error(e); }
})();
})();
